var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 7,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33365_120817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5V17.5H14.5V14.5H17.5ZM19 13H13V19H19V13ZM17.5 22.5V25.5H14.5V22.5H17.5ZM19 21H13V27H19V21ZM25.5 14.5V17.5H22.5V14.5H25.5ZM27 13H21V19H27V13ZM21 21H22.5V22.5H21V21ZM22.5 22.5H24V24H22.5V22.5ZM24 21H25.5V22.5H24V21ZM21 24H22.5V25.5H21V24ZM22.5 25.5H24V27H22.5V25.5ZM24 24H25.5V25.5H24V24ZM25.5 22.5H27V24H25.5V22.5ZM25.5 25.5H27V27H25.5V25.5ZM29 15C28.45 15 28 14.55 28 14V12H26C25.45 12 25 11.55 25 11C25 10.45 25.45 10 26 10H29C29.55 10 30 10.45 30 11V14C30 14.55 29.55 15 29 15ZM30 29V26C30 25.45 29.55 25 29 25C28.45 25 28 25.45 28 26V28H26C25.45 28 25 28.45 25 29C25 29.55 25.45 30 26 30H29C29.55 30 30 29.55 30 29ZM11 30H14C14.55 30 15 29.55 15 29C15 28.45 14.55 28 14 28H12V26C12 25.45 11.55 25 11 25C10.45 25 10 25.45 10 26V29C10 29.55 10.45 30 11 30ZM10 11V14C10 14.55 10.45 15 11 15C11.55 15 12 14.55 12 14V12H14C14.55 12 15 11.55 15 11C15 10.45 14.55 10 14 10H11C10.45 10 10 10.45 10 11Z",
    fill: "#51B15C"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 7,
    stroke: "#51B15C",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33365_120817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.7934a62038aa56f24d3c4f1eb8f6c4d1.svg";
export { ForwardRef as ReactComponent };